/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

const {colors, mediaPhone, screenSizes} = theme;

export const phoneMediaQuery = `(max-width: ${screenSizes.phone}px)`;

export const TopNavigation = styled.default.div<{isLoggedIn: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${paddings.medium};
  height: 3.5rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  ${({isLoggedIn}) => isLoggedIn && styled.css`
    background-color: ${colors.headerColor};
    padding: ${paddings.small} ${paddings.xlarge};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 3px;
      background: ${theme.brandGradient};
    }
  `}
`;

export const NavigationLeftSide = styled.default.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
`;

export const Logo = styled.default.img`
  display: block;
  height: 40px;
  width: auto;
`;

export const MenuIcon = styled.default.img`
  margin-right: ${paddings.medium};
  width: 1.5rem;
`;

export const User = styled.default.div`
  display: flex;
  align-items: center;
  min-width: 0;
  margin-left: 0;
  color: ${colors.white};

  & div[role="button"] {
    cursor: pointer;
  }
`;

export const ApplicationId = styled.default.p`
  margin: 0;
  padding: 0 ${paddings.small};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UserInitials = styled.default.div`
  color: ${colors.gray900};
  background-color: ${colors.brandOrange};
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  text-transform: uppercase;
  ${mediaPhone} {
    display: none;
  }
`;